<template>
    <div>
        <AlertDismiss ref="alertDismiss"></AlertDismiss>

        <b-pagination v-model="filter.page" :total-rows="rows" :per-page="filter.pageSize"
            aria-controls="table-list-statements" class="m-2" pills>
        </b-pagination>
    </div>
</template>
<script>
import { EventNames, InitPageSize } from '@/plugins/enums/index.js'
import AlertDismiss from '@/components/shared/Alert-dismiss.vue'
import { mapActions } from 'vuex';

export default {
    name: 'DenouncePagination',

    data() {
        return {
            filter: {
                page: 1,
                pageSize: InitPageSize.DenouncePageSize
            },

            rows: 0
        }
    },

    components: {
        AlertDismiss
    },

    async mounted() {
        await this.getCount();

        //emitimos el evento para inicializar los valores de la tabla usuarios
        await this.paginationFilter();
    },

    methods: {
        ...mapActions(["countDenunciations"]),

        paginationFilter() {
            this.$eventBus.$emit(EventNames.PaginationFilterDenounce, this.filter);
        },

        async getCount() {
            let result = await this.countDenunciations();
            if (result.isError) {
                this.$refs.alertDismiss.showAlert(result.message);
                return;
            }

            this.rows = result.data;
        }
    },

    watch: {
        //cada ves que se haga un click al paginador entonces emite el evento
        async "filter.page"() {
            this.paginationFilter();
        },
    },

    
}
</script>
<style>
    
</style>